import React from 'react';

const StepIndicator = ({ step }) => (
  <>
    <div className="flex items-center justify-center gap-4 py-4">
      {[1, 2, 3].map((s) => (
        <div key={s} className="flex items-center">
          <div
            className={`w-8 h-8 rounded-full flex items-center justify-center text-sm font-semibold ${
              step >= s ? 'bg-indigo-600 text-white' : 'bg-slate-200 text-slate-500'
            }`}
          >
            {s}
          </div>
          {s < 3 && (
            <div
              className={`w-12 h-1 mx-2 ${
                step > s ? 'bg-indigo-600' : 'bg-slate-200'
              }`}
            />
          )}
        </div>
      ))}
    </div>
    <div className="flex justify-center gap-16 text-xs text-slate-500 mb-4">
      <span>Upload</span>
      <span>Review</span>
      <span>Complete</span>
    </div>
  </>
);

export default StepIndicator;
